// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileBackSideFooter.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var Link = require('react-router').Link;
  var actionBarConfig = require('logic/data/Izenda.ReportPartTileBackSideFooterConfig');
  var Button = require('share/components/controls/Izenda.Button');

  var withProps = require('recompose').withProps;

  var ReportPartSelectionPopup = require('share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartSelectionPopup');
  var ReportPartSelectionConstants = require('logic/data/Izenda.ReportPartSelectionConstants');
  const { filter, forEach, clone, isNil, findIndex } = require('lodash/fp');

  var FooterButton = connect()(function(props) {
    if ((props.hasPrivilege && !props.hasPrivilege()) || (props.hasLicense && !props.hasLicense())) return null;

    if (props.link) {
      return (
        <Link className="u_marginLeft" to={props.link}>
          <Button label={props.label} />
        </Link>
      );
    }

    return <Button label={props.label} onClick={props.onClick} />;
  });

  /**
   * Check having right access priority.
   * @ param {Object} item
   * @ param {Array} accessPriority
   */
  var checkAccessPriority = function(item, accessPriority) {
    if (!item.accessPriority) return true;
    return (
      findIndex(function(i) {
        return i === accessPriority;
      }, item.accessPriority) !== -1
    );
  };

  var FooterButtonGroup = connect()(function(props) {
    if (props.hasPrivilege && !props.hasPrivilege()) return null;
    var accessPriority = props.accessPriority;

    var groupPrivileges = filter(function(item) {
      return item.hasPrivilege;
    }, props.btnGroup);

    var hasAccessPriority = false;
    forEach(function(item) {
      hasAccessPriority = checkAccessPriority(item, accessPriority) || hasAccessPriority;
      if (hasAccessPriority) return false;
    }, props.btnGroup);

    return (
      hasAccessPriority &&
      groupPrivileges.length > 0 && (
        <div className="btn-group dropup u_marginLeft">
          <button
            ref={function(dom) {
              dom && $izenda(dom).dropdown();
            }}
            className="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
          >
            {props.label}
            &nbsp;
            <span className="caret" />
          </button>
          <ul className="dropdown-menu">
            {props.btnGroup.map(function(option) {
              var state = option.state;
              var linkClass = classnames({ 'disabled-link': state.disabled });
              var hasRightAccessPriority = checkAccessPriority(option, accessPriority);

              return !state.hide && option.hasPrivilege && hasRightAccessPriority ? (
                <li key={option.key} className={linkClass}>
                  {option.link && !state.disabled ? (
                    <Link to={option.link}>{option.label}</Link>
                  ) : (
                    <a {...option.props}>{option.label}</a>
                  )}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )
    );
  });

  var action = withProps(function(props) {
    return {
      onSelectReportPartButton: function() {
        var dashboardPart = props.dashboardPart;
        var store = props.store;
        var dashboardPartType = clone(props.dashboardPart.typeConfig);
        var loader = props.loader;

        props.openPopup(ReportPartSelectionPopup, {
          onChange: function(result) {
            var reportPart = result.reportPart;
            var report = result.report;

            loader.startLoading();
            store
              .setDashboardTileType(dashboardPart, dashboardPartType, reportPart, report)
              .finally(loader.endLoading.bind(loader));
          },
          type: ReportPartSelectionConstants.TYPE.REPORT_PART
        });
      }
    };
  });

  var ReportPartTileBackSideFooter = connect(action)(function(props) {
    var dashboardPart = props.dashboardPart;
    var reportPart = dashboardPart.reportPart;
    var buttonConfig = actionBarConfig(reportPart.reportId, reportPart.id, props);
    buttonConfig = filter(function(config) {
      return (isNil(config.hasPrivilege) || config.hasPrivilege) && (isNil(config.hasLicense) || config.hasLicense);
    }, buttonConfig);

    return (
      <div className="izenda-ActionBarRight u_paddingRight">
        {buttonConfig.map(function(info) {
          return info.btnGroup ? (
            <FooterButtonGroup {...info} accessPriority={reportPart.accessPriority} />
          ) : (
            <FooterButton {...info} />
          );
        })}
      </div>
    );
  });

  ReportPartTileBackSideFooter.propsType = {
    dashboardPart: React.PropTypes.object.isRequired,
    onSelectReportPartButton: React.PropTypes.func.isRequired
  };
  module.exports = ReportPartTileBackSideFooter;
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/ReportPartTile/Izenda.ReportPartTileBackSideFooter.jsx